import { render, staticRenderFns } from "./HappAdmin.vue?vue&type=template&id=4605d5be"
import script from "./HappAdmin.vue?vue&type=script&lang=js"
export * from "./HappAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports